import { defineComponent as _defineComponent } from 'vue'
import TagsContainer from '@sh/components/MediaManager/TagsContainer/TagsContainer.ts.vue';
import UiButton from '@sh/components/Ui/UiButton.ts.vue';
import UiHeading from '@sh/components/Ui/UiHeading.ts.vue';
import Checkbox from '@sh/components/Utils/Checkbox.ts.vue';
import { MediaManagerHelpers, onImageError } from '@sh/helpers';
import { MediaManager } from '@sh/types';
import { computed } from 'vue';

interface Props {
  itemAd: MediaManager.ActiveAd;
  isSelectionActivated?: boolean;
  isLoading?: boolean;
  headingLevel?: number;
  isActiveAd?: boolean;
  ctaButton?: {
    text?: string;
    link?: string;
  };
}

interface Emits {
  (e: 'onAdModalOpen'): void;
}


export default /*#__PURE__*/_defineComponent({
  __name: 'PreviewAdCard.ts',
  props: {
    itemAd: null,
    isSelectionActivated: { type: Boolean, default: false },
    isLoading: { type: Boolean, default: false },
    headingLevel: { default: 6 },
    isActiveAd: { type: Boolean, default: true },
    ctaButton: null
  },
  emits: ["onAdModalOpen"],
  setup(__props: any, { emit }: { emit: ({
  (e: 'onAdModalOpen'): void;
}), expose: any, slots: any, attrs: any }) {

const props = __props as { itemAd: MediaManager.ActiveAd, isSelectionActivated: boolean, isLoading: boolean, headingLevel: number, isActiveAd: boolean, ctaButton?: {
    text?: string;
    link?: string;
  } };

/* Copy from shared/src/components/CreativeLibrary/PreviewAdCard.ts.vue with small style changes */




const showTags = computed<string[]>(() => MediaManagerHelpers.getTagsToDisplay(props.itemAd.tags));

const onCardContainerClick = (event: Event) => {
  if (props.isSelectionActivated || (event.target as HTMLElement).closest('.checkbox')) {
    props.itemAd.selected = !props.itemAd.selected;
  } else {
    emit('onAdModalOpen');
  }
};

const onSelectClick = (value: boolean) => {
  props.itemAd.selected = value;
};

const onCtaButtonClick = (link?: string) => {
  console.log('link', link);
  if (link) {
    window.open(link, '_blank');
  }
};

return { __sfc: true,props, emit, showTags, onCardContainerClick, onSelectClick, onCtaButtonClick, TagsContainer, UiButton, UiHeading, Checkbox, onImageError }
}

})